const POST_REPORT = 'report/POST_REPORT';

const FETCH_REPORT_CATEGORIES = 'report/FETCH_REPORT_CATEGORIES';

const FETCH_STORY_EPISODES = 'report/FETCH_STORY_EPISODES';

const RESET_EPISODES = 'report/RESET_EPISODES';

export default {
  POST_REPORT,
  FETCH_REPORT_CATEGORIES,
  FETCH_STORY_EPISODES,
  RESET_EPISODES,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/report/types.js